import React from "react";
import { HiCheck, HiX } from "react-icons/hi";
import { cn } from "@/lib/utils";
import { FEATURES } from "@/consts/stripe";

type FeaturesProps = {
  plans: string[];
};

const FeaturesTable: React.FC<FeaturesProps> = ({ plans }) => {
  if (!plans || plans.length === 0) return null;

  return (
    <div className="mx-auto flex max-w-[1000px] flex-col items-start justify-start space-y-10 px-6">
      <h2 className="flex items-start justify-start self-center pl-2 pt-4 text-left text-5xl font-semibold">
        Features
      </h2>
      <div className="grid w-full grid-cols-5">
        <div className="sticky -left-1 col-span-2 flex flex-col items-start">
          <div className="w-full overflow-hidden rounded-l-lg bg-[#F5F7FA] text-left">
            <div className="w-full whitespace-nowrap p-2 text-xs font-medium md:text-sm lg:text-base">
              Monthly Limit
            </div>
          </div>
          {FEATURES.map((key, i) => (
            <div
              key={key.type}
              className={cn(
                "w-full overflow-hidden bg-white",
                i !== FEATURES.length - 1 && "border-b border-gray-200/50",
              )}
            >
              <div className="w-3/4 whitespace-nowrap px-3 py-4 text-xs leading-6 text-black md:text-sm lg:text-base">
                {key.type}
              </div>
            </div>
          ))}
        </div>
        {plans.map((plan, index) => (
          <div key={plan} className="flex flex-col items-start">
            <div
              className={cn(
                "w-full bg-[#F5F7FA] p-2 text-xs font-medium capitalize md:text-sm lg:text-base",
                plan === "Clipper"
                  ? "font-semibold text-[#335CFF]"
                  : plan === "Pro"
                    ? "text-black"
                    : "",
                { "rounded-r-lg": index === plans.length - 1 },
              )}
            >
              {plan}
            </div>

            {FEATURES.map((key, i) => {
              const value = key[plan.toLowerCase() as "hobby" | "clipper" | "pro"];
              return (
                <div
                  key={key.type}
                  className={cn(
                    "w-full whitespace-nowrap bg-white px-2 py-4",
                    i !== FEATURES.length - 1 && "border-b border-gray-200/50",
                    { "rounded-r-lg": plan === plans[plans.length - 1] },
                  )}
                >
                  {renderFeatureValue(value, plan)}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

const renderFeatureValue = (value: string | number, plan: string) => {
  if (value === "✓") {
    return (
      <HiCheck
        className={cn(
          "text-20 -ml-1 inline-block",
          plan === "Clipper"
            ? "text-[#25B3FE]"
            : plan === "Pro"
              ? "text-[#1387FF]"
              : "text-green-500",
        )}
      />
    );
  } else if (value === "✕") {
    return <HiX className="text-20 -ml-1 inline-block text-red-500" />;
  }
  return (
    <span
      className={cn(
        "text-xs md:text-sm lg:text-base",
        plan === "Clipper" ? "font-semibold text-[#335CFF]" : plan === "Pro" ? "text-black" : "",
      )}
    >
      {value}
    </span>
  );
};

export default FeaturesTable;
